import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import each from 'lodash/each';
import get from 'lodash/get';
import {
  QUESTION_TYPE__SCALE,
} from '../constants';

export function isNilValue(value) {
  return (
    value === undefined ||
    value === null ||
    value === '' ||
    (isArray(value) && value.length === 0)
  );
}

export function hasNoElements({
  _elements,
  _elementsOrder,
}) {
  if (_elementsOrder) {
    return isEmpty(_elementsOrder);
  }
  return isEmpty(_elements);
}

export function isEmptyAnswer(answer) {
  if (!answer) {
    return true;
  }
  return hasNoElements(answer) && isNilValue(answer.value);
}

export function parseValueExpr(value) {
  // NOTE: In the future we may want to use
  //       a more sophisticated parser.
  if (value === true) {
    return 1;
  }
  if (value === false) {
    return 0;
  }
  return +value;
}

export function isEmptyAnswerAsMongoExpression(id) {
  return {
    $or: [
      {
        $eq: [
          `${id}.value`,
          null,
        ],
      },
      {
        $eq: [
          `${id}.value`,
          '',
        ],
      },
      {
        $and: [
          {
            $isArray: `${id}.value`,
          },
          {
            $eq: [
              {
                $size: `${id}.value`,
              },
              0,
            ],
          },
        ],
      },
    ],
  };
}

export const getFormattedScaleValue = ({
  question,
  value,
}) => {
  if (question.type !== QUESTION_TYPE__SCALE) {
    return null;
  }

  const {
    scaleLabels,
  } = question;

  if (!scaleLabels) {
    return value;
  }

  let formattedValue;

  each(scaleLabels, (scaleLabel, i) => {
    if (Number(scaleLabel.value) === value) {
      formattedValue = scaleLabel.label;

      return false;
    }

    if (scaleLabel.value > value) {
      const prevScaleLabel = scaleLabels[i - 1];

      formattedValue = `${get(prevScaleLabel, 'label')} - ${scaleLabel.label}`;

      return false;
    }

    return true;
  });

  return formattedValue;
};
